import { Box, Container, Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ErrorBoundary } from '@scoir/error-reporter'
import { PageTitle } from '@scoir/headers'
// @ts-expect-error - not typed
import Tabs from '@scoir/tabs'
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'

import EngageSplashPage from 'components/EngageSplashPage'

import OutreachMessages from './OutreachMessages'
import { useOutreachTabs } from './OutreachMessages/use-outreach-tabs'
import { AUTOMATED, ONE_TIME, OUTREACH_MESSAGE_TYPES } from './outreach-message-types'

const useStyles = makeStyles({
  root: {
    minHeight: 0,
    backgroundColor: 'white',
    '& a:hover, & a:focus': {
      outline: 'none',
      textDecoration: 'none',
    },
  },
})

const MESSAGE_ROUTE_ENDPOINTS = Object.keys(OUTREACH_MESSAGE_TYPES)

interface OutreachProps extends RouteComponentProps {
  canManageOutreach: boolean
  supportsStudentOutreach: boolean
  supportsLimitedAutomatedMessages: boolean
}

export const Outreach = ({
  match,
  location,
  canManageOutreach,
  supportsStudentOutreach,
  supportsLimitedAutomatedMessages,
}: OutreachProps) => {
  const classes = useStyles()
  const tabs = useOutreachTabs(match.url)
  const currentTab = location.pathname.split('/').pop()

  if (!canManageOutreach) {
    return (
      <EngageSplashPage
        type="messaging"
        featureEnabled={supportsStudentOutreach || supportsLimitedAutomatedMessages}
      />
    )
  }

  return (
    <Container
      className="outreach"
      maxWidth="xl"
    >
      <PageTitle title="Outreach Messages" />
      <Box bgcolor="background.paper">
        <Tabs
          scrollButtons="off"
          id="outreach-message-type"
          textColor="inherit"
          items={tabs}
          value={currentTab}
          classes={classes}
        >
          <Divider />
          <ErrorBoundary>
            <Switch>
              <Route
                exact
                path={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[0]}`}
                render={() => <OutreachMessages currentRouteEndpoint={ONE_TIME} />}
              />
              <Route
                exact
                path={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[1]}`}
                render={() => <OutreachMessages currentRouteEndpoint={AUTOMATED} />}
              />
              {supportsLimitedAutomatedMessages ? (
                <Redirect to={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[1]}`} />
              ) : (
                <Redirect to={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[0]}`} />
              )}
            </Switch>
          </ErrorBoundary>
        </Tabs>
      </Box>
    </Container>
  )
}

export default Outreach
